import {Container, Grid, Paper, TableBody, TableHead} from "@mui/material";
import {
    StyledButtonContainer, StyledButtonOrange,
    StyledTable, StyledTableBodyRow,
    StyledTableCell, StyledTableCellHeader, StyledTableContainer,
    StyledTableHeadRow
} from "../../styles/MyStyles";
import React, {useEffect, useState} from "react";
import * as DataProvider from "../../logic/DataProvider";
import {GetLookupValue, GetLookupValueName} from "../../logic/LookupHelper";
import {useNavigate} from "react-router-dom";


const BankAccountsPage = () => {
    const navigate = useNavigate();
    const [bankAccounts, setBankAccounts] = useState([]);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        try {
            let bundle = DataProvider.GetClientBundle();
            if (bundle.bankAccounts) {
                let entities = bundle.bankAccounts;
                setBankAccounts(JSON.parse(JSON.stringify(entities)));
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleRequestNew = () => {
        navigate(`request`);
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <StyledButtonContainer container>
                <Grid>
                    <StyledButtonOrange variant="contained" onClick={handleRequestNew}>
                        New
                    </StyledButtonOrange>
                </Grid>
            </StyledButtonContainer>
            <StyledTableContainer component={Paper}>
                <StyledTable>
                    <TableHead>
                        <StyledTableHeadRow>
                            <StyledTableCellHeader columncount={6}>Bank</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={6}>Bank Country</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={6}>Bank Swift</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={6}>Bank Address</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={6}>Asset</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={6}>Iban</StyledTableCellHeader>
                        </StyledTableHeadRow>
                    </TableHead>
                    <TableBody>
                        {bankAccounts && bankAccounts.map((bankAccount) => (
                            <StyledTableBodyRow key={bankAccount.id}>
                                <StyledTableCell>{GetLookupValueName('bank', bankAccount.bankId)}</StyledTableCell>
                                <StyledTableCell>{GetLookupValueName('country', GetLookupValue('bank', bankAccount.bankId).countryId)}</StyledTableCell>
                                <StyledTableCell>{GetLookupValue('bank', bankAccount.bankId).swift}</StyledTableCell>
                                <StyledTableCell>{GetLookupValue('bank', bankAccount.bankId).address}</StyledTableCell>
                                <StyledTableCell>{GetLookupValueName('asset', bankAccount.assetId)}</StyledTableCell>
                                <StyledTableCell>{bankAccount.iban}</StyledTableCell>
                            </StyledTableBodyRow>
                        ))}
                    </TableBody>
                </StyledTable>
            </StyledTableContainer>
        </Container>
    );
};
export default BankAccountsPage;